import { render } from "./RoomDetail.vue?vue&type=template&id=45b4ee48&scoped=true"
import script from "./RoomDetail.vue?vue&type=script&lang=js"
export * from "./RoomDetail.vue?vue&type=script&lang=js"

import "./RoomDetail.vue?vue&type=style&index=0&id=45b4ee48&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/alice/alice_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45b4ee48"]])

export default __exports__